/* eslint-disable react/jsx-no-literals */
/* eslint-disable complexity */
import React from 'react';

import Tooltip from 'carbon-react/lib/components/tooltip';

import { FormattedMessage, useIntl } from '@futrli/localisation';

import {
  FORMULA_ACTIONS,
  getFormulaActionsPlaceholder
} from '../../../ui/data-builder/formula-content-form/formula-actions/const';

import * as styles from './row-formula.scss';

interface Props {
  handleActionClick: (action: string) => void;
}

export const ActionButtons = ({ handleActionClick }: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.actionsButtonContainer} onMouseDown={event => event.preventDefault()}>
      <div className={styles.description}>
        <FormattedMessage
          id="reporting.type_at_for_account_category_group"
          defaultMessage="Type @ for account category, group, account, prediction and formula references."
        />
      </div>
      <div className={styles.actionsSection}>
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', width: 260, bottom: 36 }} className={styles.actionTitle}>
            <FormattedMessage id="reporting.use_after_at_reference" defaultMessage="Use after an @ reference" />
          </div>
          <button type="button" className={styles.actionOperator} onClick={() => handleActionClick('+')}>
            +
          </button>
        </div>
        <button type="button" className={styles.actionOperator} onClick={() => handleActionClick('-')}>
          -
        </button>
        <button type="button" className={styles.actionOperator} onClick={() => handleActionClick('*')}>
          &times;
        </button>
        <button
          type="button"
          className={styles.actionOperator}
          onClick={() => handleActionClick('/')}
          style={{ marginRight: 140 }}
        >
          &divide;
        </button>
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', width: 340, bottom: 36 }} className={styles.actionTitle}>
            <FormattedMessage id="predict.use_for_conditionals" defaultMessage="Use for conditionals" />
          </div>
          <button
            type="button"
            className={styles.actionButton}
            onClick={() => handleActionClick(getFormulaActionsPlaceholder(intl)[FORMULA_ACTIONS.if])}
          >
            <Tooltip message={<div>{getFormulaActionsPlaceholder(intl)[FORMULA_ACTIONS.if]}</div>} position="top">
              <div>
                <FormattedMessage id="formula.if" defaultMessage="IF" />
              </div>
            </Tooltip>
          </button>
        </div>
        <button type="button" className={styles.actionOperator} onClick={() => handleActionClick('<')}>
          &lt;
        </button>
        <button type="button" className={styles.actionOperator} onClick={() => handleActionClick('>')}>
          &gt;
        </button>
        <button type="button" className={styles.actionOperator} onClick={() => handleActionClick('<=')}>
          &le;
        </button>
        <button type="button" className={styles.actionOperator} onClick={() => handleActionClick('>=')}>
          &ge;
        </button>
        <button type="button" className={styles.actionOperator} onClick={() => handleActionClick('=')}>
          =
        </button>
      </div>
    </div>
  );
};
